var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-table',{attrs:{"data":_vm.tableData,"hoverable":"","draggable":""},on:{"dragstart":_vm.dragstart,"dragover":_vm.dragover,"dragleave":_vm.dragleave,"drop":_vm.drop}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }